/* SNZ-ZOOM v1 (7 Oct 2026) - replaces Dawn's fixed-crop product modal with a
   full-screen viewer: image opens fitted to the screen, pinch / double-tap /
   wheel to zoom (1x-4x), drag to pan anywhere in the photo, swipe between
   photos, swipe down or Esc to close. Dawn's original modal is the fallback
   (video / 3D media, or if anything here fails). */
(function () {
  if (window.SnzZoom) return;
  var MAX = 4, DT = 2.5, doc = document;
  var css =
    '.snzz{position:fixed;inset:0;z-index:2147483000;background:rgb(var(--color-background,255,255,255));opacity:0;transition:opacity .22s ease;-webkit-user-select:none;user-select:none;-webkit-touch-callout:none}' +
    '.snzz.is-open{opacity:1}.snzz__stage{position:absolute;inset:0;overflow:hidden;touch-action:none;cursor:zoom-in}' +
    '.snzz.is-zoomed .snzz__stage{cursor:grab}.snzz.is-drag .snzz__stage{cursor:grabbing}' +
    '.snzz__track{position:absolute;inset:0;will-change:transform}' +
    '.snzz__slide{position:absolute;top:0;height:100%;overflow:hidden}' +
    '.snzz__img{position:absolute;left:50%;top:50%;max-width:none;transform-origin:50% 50%;will-change:transform;pointer-events:none;-webkit-user-drag:none;background:rgba(0,0,0,.03)}' +
    '.snzz__btn{position:absolute;z-index:2;width:44px;height:44px;border-radius:50%;border:1px solid rgba(18,18,18,.12);background:rgba(255,255,255,.94);color:#121212;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;box-shadow:0 2px 10px rgba(0,0,0,.08);transition:opacity .2s}' +
    '.snzz__btn svg{width:18px;height:18px;fill:none;stroke:currentColor;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round}' +
    '.snzz__close{top:16px;right:16px}.snzz__prev{left:16px;top:50%;margin-top:-22px}.snzz__next{right:16px;top:50%;margin-top:-22px}' +
    '.snzz__btn[disabled]{opacity:0;pointer-events:none}' +
    '.snzz__count{position:absolute;z-index:2;top:27px;left:20px;font:500 13px/1 var(--font-body-family,inherit);letter-spacing:.06em;color:#121212;background:rgba(255,255,255,.9);padding:6px 10px;border-radius:14px}' +
    '.snzz__hint{position:absolute;z-index:2;left:50%;bottom:calc(24px + env(safe-area-inset-bottom));transform:translateX(-50%);background:rgba(18,18,18,.78);color:#fff;font:400 13px/1.2 var(--font-body-family,inherit);padding:9px 16px;border-radius:20px;white-space:nowrap;pointer-events:none;transition:opacity .4s}' +
    '.snzz__hint.is-gone{opacity:0}' +
    '@media (hover:none){.snzz__prev,.snzz__next{display:none}}' +
    '@media (prefers-reduced-motion:reduce){.snzz,.snzz__track,.snzz__img{transition:none!important}}';
  var ICON = {
    close: '<svg viewBox="0 0 20 20"><path d="M4 4l12 12M16 4L4 16"/></svg>',
    prev: '<svg viewBox="0 0 20 20"><path d="M12.5 4l-6 6 6 6"/></svg>',
    next: '<svg viewBox="0 0 20 20"><path d="M7.5 4l6 6-6 6"/></svg>'
  };
  var styled = false, hinted = false;

  function hiRes(src) {
    if (!src) return src;
    return /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=2400') : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=2400';
  }
  function el(tag, cls, html) { var e = doc.createElement(tag); if (cls) e.className = cls; if (html) e.innerHTML = html; return e; }

  function open(slides, start, opener) {
    if (!styled) { var st = el('style'); st.textContent = css; doc.head.appendChild(st); styled = true; }
    var root = el('div', 'snzz'), stage = el('div', 'snzz__stage'), track = el('div', 'snzz__track');
    root.setAttribute('role', 'dialog'); root.setAttribute('aria-modal', 'true'); root.setAttribute('aria-label', 'Product photo zoom');
    var bClose = el('button', 'snzz__btn snzz__close', ICON.close), bPrev = el('button', 'snzz__btn snzz__prev', ICON.prev), bNext = el('button', 'snzz__btn snzz__next', ICON.next);
    bClose.type = bPrev.type = bNext.type = 'button';
    bClose.setAttribute('aria-label', 'Close'); bPrev.setAttribute('aria-label', 'Previous photo'); bNext.setAttribute('aria-label', 'Next photo');
    var count = el('div', 'snzz__count'); count.setAttribute('aria-live', 'polite');
    var coarse = window.matchMedia('(hover: none)').matches;
    var hint = el('div', 'snzz__hint'); hint.textContent = coarse ? 'Pinch or double-tap to zoom' : 'Scroll or double-click to zoom · drag to move';
    stage.appendChild(track); root.appendChild(stage); root.appendChild(count); root.appendChild(bClose);
    if (slides.length > 1) { root.appendChild(bPrev); root.appendChild(bNext); } else count.style.display = 'none';
    if (!hinted) root.appendChild(hint);

    var items = slides.map(function (s) {
      var sl = el('div', 'snzz__slide'), im = el('img', 'snzz__img');
      im.alt = s.alt || ''; im.draggable = false; im.decoding = 'async';
      sl.appendChild(im); track.appendChild(sl);
      return { s: s, sl: sl, im: im, loaded: false, w: 0, h: 0 };
    });

    var W = 0, H = 0, idx = start, sc = 1, tx = 0, ty = 0, trackX = 0;
    var htmlOv = doc.documentElement.style.overflow, bodyOv = doc.body.style.overflow;

    function load(i) { var it = items[i]; if (!it || it.loaded) return; it.loaded = true; it.im.src = it.s.src; }
    function fit(it) {
      var nw = it.s.w || 1000, nh = it.s.h || 1000, pad = coarse ? 0 : 48;
      var k = Math.min((W - pad * 2) / nw, (H - pad * 2) / nh);
      it.w = nw * k; it.h = nh * k;
      it.im.style.width = it.w + 'px'; it.im.style.height = it.h + 'px';
      it.im.style.marginLeft = -it.w / 2 + 'px'; it.im.style.marginTop = -it.h / 2 + 'px';
    }
    function layout() {
      W = stage.clientWidth; H = stage.clientHeight;
      items.forEach(function (it, i) { it.sl.style.left = i * W + 'px'; it.sl.style.width = W + 'px'; fit(it); });
      var c = clampT(sc, tx, ty); setZoom(sc, c[0], c[1], false); setTrack(-idx * W, false);
    }
    function bounds(s) { var it = items[idx]; return { x: Math.max(0, (it.w * s - W) / 2), y: Math.max(0, (it.h * s - H) / 2) }; }
    function clampT(s, x, y) { var b = bounds(s); return [Math.max(-b.x, Math.min(b.x, x)), Math.max(-b.y, Math.min(b.y, y))]; }
    function rubber(v, b) { return v > b ? b + (v - b) * 0.3 : v < -b ? -b + (v + b) * 0.3 : v; }
    function setZoom(s, x, y, anim) {
      sc = s; tx = x; ty = y;
      var im = items[idx].im;
      im.style.transition = anim ? 'transform .32s cubic-bezier(.2,.8,.2,1)' : 'none';
      im.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0) scale(' + s + ')';
      root.classList.toggle('is-zoomed', s > 1.01);
    }
    function setTrack(x, anim) {
      trackX = x;
      track.style.transition = anim ? 'transform .34s cubic-bezier(.2,.8,.2,1)' : 'none';
      track.style.transform = 'translate3d(' + x + 'px,0,0)';
    }
    function settle(vx, vy) {
      var s = Math.min(MAX, Math.max(1, sc));
      var x = tx + (vx || 0) * 160, y = ty + (vy || 0) * 160;
      if (s !== sc) { var r = s / sc; x = tx * r; y = ty * r; }
      var c = clampT(s, x, y);
      setZoom(s, c[0], c[1], true);
    }
    function zoomAt(s, px, py, anim) {
      s = Math.min(MAX, Math.max(1, s));
      var cx = px - W / 2, cy = py - H / 2, r = s / sc;
      var c = clampT(s, cx - (cx - tx) * r, cy - (cy - ty) * r);
      setZoom(s, c[0], c[1], anim);
    }
    function go(i) {
      if (i < 0 || i >= items.length) { setTrack(-idx * W, true); return; }
      if (i !== idx) { setZoom(1, 0, 0, true); }
      idx = i; sc = 1; tx = 0; ty = 0;
      load(i); load(i + 1); load(i - 1);
      setTrack(-idx * W, true);
      count.textContent = (idx + 1) + ' / ' + items.length;
      bPrev.disabled = idx === 0; bNext.disabled = idx === items.length - 1;
      root.classList.remove('is-zoomed');
    }
    function dropHint() { if (!hinted) { hinted = true; hint.classList.add('is-gone'); } }

    // ---- pointer gestures ----
    var pts = new Map(), mode = null, st0 = null, lastTap = null, vel = { x: 0, y: 0, t: 0, px: 0, py: 0 };
    function mid() { var a = Array.from(pts.values()); return { x: (a[0].x + a[1].x) / 2, y: (a[0].y + a[1].y) / 2, d: Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y) || 1 }; }
    function begin1(p) { st0 = { x: p.x, y: p.y, tx: tx, ty: ty, trackX: trackX, t: performance.now() }; vel = { x: 0, y: 0, t: st0.t, px: p.x, py: p.y }; }
    function rel(e) { var r = stage.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; }

    stage.addEventListener('pointerdown', function (e) {
      if (e.button > 0) return;
      try { stage.setPointerCapture(e.pointerId); } catch (_) {}
      pts.set(e.pointerId, rel(e));
      if (pts.size === 1) { mode = null; begin1(rel(e)); }
      else if (pts.size === 2) {
        var m = mid(); mode = 'pinch'; dropHint();
        if (trackX !== -idx * W) setTrack(-idx * W, true);
        st0 = { m: m, s: sc, tx: tx, ty: ty };
      }
    });
    stage.addEventListener('pointermove', function (e) {
      if (!pts.has(e.pointerId)) return;
      var p = rel(e); pts.set(e.pointerId, p);
      if (mode === 'pinch' && pts.size >= 2) {
        var m = mid(), s = Math.max(0.6, Math.min(MAX * 1.4, st0.s * m.d / st0.m.d));
        var qx = (st0.m.x - W / 2 - st0.tx) / st0.s, qy = (st0.m.y - H / 2 - st0.ty) / st0.s;
        setZoom(s, m.x - W / 2 - qx * s, m.y - H / 2 - qy * s, false);
        return;
      }
      if (pts.size !== 1 || !st0) return;
      var dx = p.x - st0.x, dy = p.y - st0.y, now = performance.now();
      if (now - vel.t > 0) { vel.x = (p.x - vel.px) / (now - vel.t); vel.y = (p.y - vel.py) / (now - vel.t); vel.t = now; vel.px = p.x; vel.py = p.y; }
      if (!mode) {
        if (Math.hypot(dx, dy) < 7) return;
        mode = sc > 1.01 ? 'pan' : (Math.abs(dx) > Math.abs(dy) ? 'swipe' : 'down');
        root.classList.add('is-drag');
      }
      if (mode === 'pan') { var b = bounds(sc); setZoom(sc, rubber(st0.tx + dx, b.x), rubber(st0.ty + dy, b.y), false); }
      else if (mode === 'swipe') {
        var edge = (idx === 0 && dx > 0) || (idx === items.length - 1 && dx < 0);
        setTrack(st0.trackX + (edge ? dx * 0.3 : dx), false);
      } else if (mode === 'down') {
        var d = Math.max(0, dy);
        items[idx].im.style.transition = 'none';
        items[idx].im.style.transform = 'translate3d(0,' + d + 'px,0) scale(' + (1 - Math.min(d / H, 0.25)) + ')';
        root.style.opacity = String(1 - Math.min(d / (H * 0.8), 0.6));
      }
    });
    function end(e) {
      if (!pts.has(e.pointerId)) return;
      pts.delete(e.pointerId);
      if (mode === 'pinch') {
        if (pts.size === 1) { mode = sc > 1.01 ? 'pan' : null; begin1(pts.values().next().value); if (mode === 'pan') root.classList.add('is-drag'); return; }
        if (pts.size === 0) { mode = null; root.classList.remove('is-drag'); settle(); }
        return;
      }
      if (pts.size) return;
      root.classList.remove('is-drag');
      if (!st0) return;
      var p = rel(e), dx = p.x - st0.x, dy = p.y - st0.y, dt = performance.now() - st0.t;
      var stale = performance.now() - vel.t > 80;
      var vx = stale ? 0 : vel.x, vy = stale ? 0 : vel.y;
      if (mode === 'pan') settle(vx, vy);
      else if (mode === 'swipe') go(dx < -W * 0.18 || vx < -0.45 ? idx + 1 : dx > W * 0.18 || vx > 0.45 ? idx - 1 : idx);
      else if (mode === 'down') {
        if (dy > 110 || vy > 0.6) close();
        else { root.style.opacity = ''; setZoom(1, 0, 0, true); }
      } else if (dt < 300) {
        var now = performance.now();
        if (lastTap && now - lastTap.t < 320 && Math.hypot(p.x - lastTap.x, p.y - lastTap.y) < 30) {
          lastTap = null; dropHint();
          if (sc > 1.01) setZoom(1, 0, 0, true); else zoomAt(DT, p.x, p.y, true);
        } else lastTap = { t: now, x: p.x, y: p.y };
      }
      mode = null;
    }
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);
    stage.addEventListener('wheel', function (e) {
      e.preventDefault(); dropHint();
      var p = rel(e), k = Math.exp(-e.deltaY * (e.ctrlKey ? 0.01 : 0.0025));
      zoomAt(sc * k, p.x, p.y, false);
    }, { passive: false });
    // Safari's own pinch-to-zoom-the-page gesture would fight ours
    ['gesturestart', 'gesturechange'].forEach(function (n) { root.addEventListener(n, function (e) { e.preventDefault(); }); });

    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowRight') go(idx + 1);
      else if (e.key === 'ArrowLeft') go(idx - 1);
      else if (e.key === '+' || e.key === '=') zoomAt(sc * 1.5, W / 2, H / 2, true);
      else if (e.key === '-') zoomAt(sc / 1.5, W / 2, H / 2, true);
      else if (e.key === 'Tab') { var f = [bClose, bPrev, bNext].filter(function (b) { return b.isConnected && !b.disabled; }); var i = f.indexOf(doc.activeElement); e.preventDefault(); f[(i + (e.shiftKey ? f.length - 1 : 1)) % f.length].focus(); }
    }
    var closed = false;
    function close() {
      if (closed) return; closed = true;
      doc.removeEventListener('keydown', onKey); window.removeEventListener('resize', layout);
      root.classList.remove('is-open'); root.style.opacity = '';
      setTimeout(function () { root.remove(); }, 230);
      doc.documentElement.style.overflow = htmlOv; doc.body.style.overflow = bodyOv;
      if (opener && opener.focus) { try { opener.focus({ preventScroll: true }); } catch (_) {} }
    }
    bClose.addEventListener('click', close);
    bPrev.addEventListener('click', function () { go(idx - 1); });
    bNext.addEventListener('click', function () { go(idx + 1); });
    doc.addEventListener('keydown', onKey); window.addEventListener('resize', layout);

    items.forEach(function (it) { it.im.addEventListener('load', function () { it.im.style.background = 'none'; }); });
    doc.documentElement.style.overflow = 'hidden'; doc.body.style.overflow = 'hidden';
    doc.body.appendChild(root);
    layout(); go(start); setTrack(-idx * W, false);
    requestAnimationFrame(function () { root.classList.add('is-open'); bClose.focus({ preventScroll: true }); });
    if (!hinted) setTimeout(dropHint, 2800);
  }
  window.SnzZoom = { open: open, hiRes: hiRes };
})();

customElements.get("product-modal") || customElements.define("product-modal", class extends ModalDialog {
  constructor() { super(); }
  hide() { super.hide(); }
  show(opener) {
    try {
      var id = opener && opener.getAttribute("data-media-id"), slides = this.snzSlides(), i = -1;
      slides.forEach(function (s, n) { if (s.id === id) i = n; });
      if (i > -1 && window.SnzZoom) { window.SnzZoom.open(slides, i, opener); return; }
    } catch (err) { if (window.console) console.warn("snz-zoom fallback", err); }
    super.show(opener); this.showActiveMedia();
  }
  /* Photos in gallery order; the gallery list is already variant-filtered server-side, and the thumbnail layout hides inactive slides, so no display check. */
  snzSlides() {
    var modal = this, out = [], seen = {};
    var section = this.closest("section") || document;
    var lis = Array.prototype.slice.call(section.querySelectorAll(".product__media-list .product__media-item[data-media-id]"));
    lis.forEach(function (li) {
      var full = li.getAttribute("data-media-id"), id = full.slice(full.lastIndexOf("-") + 1);
      if (seen[id]) return;
      var img = modal.querySelector('img[data-media-id="' + id + '"]');
      if (!img) return;
      seen[id] = 1;
      out.push({ id: id, src: window.SnzZoom.hiRes(img.getAttribute("src")), alt: img.getAttribute("alt"), w: +img.getAttribute("width") || 0, h: +img.getAttribute("height") || 0 });
    });
    return out;
  }
  showActiveMedia() { this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach(element => { element.classList.remove("active") }); const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`), activeMediaTemplate = activeMedia.querySelector("template"), activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null; activeMedia.classList.add("active"), activeMedia.scrollIntoView(); const container = this.querySelector('[role="document"]'); container.scrollLeft = (activeMedia.width - container.clientWidth) / 2, activeMedia.nodeName == "DEFERRED-MEDIA" && activeMediaContent && activeMediaContent.querySelector(".js-youtube") && activeMedia.loadContent() }
});
